<ng-container *ngIf="params">
	<ng-container *ngIf="mode == 'popup'">
		<label *ngIf="expiredPosition === undefined">
			<div
				class=" pointer mx-md-0 shadow-kp border-dark-gray {{callToActionMode ? ' yellow-bg border rounded-xl mx-2 p-2 ': ' f-white dark-gray-bg p-1'}}"
				(click)="toggleSubscribe($event)">
				<div class="d-flex" *ngIf="callToActionMode">
					<i class="fa fa-bell fs-lg ml-1 p-1"></i>
					<div class="fs-sm">هر لحظه ممکنه یه آگهی جدید به این صفحه اضافه بشه</div>
				</div>
				<div class="d-flex align-items-center" [class.f-yellow]="!callToActionMode">
					<i *ngIf="!callToActionMode" class="fa fa-bell fs-lg ml-1 p-1"></i>
					<div class="flex-fill">
						<div *ngIf="!(currentSubscription$|async)" [class.fw-bold]="callToActionMode">آگهی جدید اضافه شد خبرم کن!
						</div>
						<div *ngIf="user && (currentSubscription$|async)">
							<div *ngIf="user.Seeker?.ExpiredPromote === false;">
								آگهی جدید اضافه شد خبرت می‌کنیم.
							</div>
							<div *ngIf="user.Seeker?.ExpiredPromote !== false;" class="text-center">
								این جستجو برای شما ثبت شده ولی بسته کارجوی پیشتاز شما فعال نیست.
								<div class="mt-1 ">
									<a type="button" class="btn btn-vanguard btn-sm" routerLink="/seeker/karpasha"
										click-stop-propagation>خرید بسته کارجوی پیشتاز</a>
								</div>
							</div>
						</div>
					</div>
					<div class="toggle-switch-container ">
						<label class="toggle-switch mb-0">
							<input type="checkbox" name="showowned" [ngModel]="!!(currentSubscription$|async)">
							<span class="slider round"></span>
						</label>
					</div>
				</div>
			</div>
		</label>
		<ng-container *ngIf="expiredPosition !== undefined">
			<div class="kp-questioner p-3" *ngIf="!(currentSubscription$|async)" (click)="toggleSubscribe($event)">
				<h4>
					<i class="fa fa-exclamation-triangle ml-2"></i>
					در هیچ سایتی،
					<ng-container *ngIf="expiredPosition===0">آگهی فعالی</ng-container>
					<ng-container *ngIf="expiredPosition>0">آگهی فعال دیگه‌ای</ng-container>
					با این جستجو وجود نداره.
				</h4>
				<div class="py-1 d-flex align-items-center justify-content-center">
					<h4>اگه آگهی جدید پیدا شد؛</h4>
					<a class="btn btn-primary mx-3">به من خبر بده!</a>
				</div>
				<!-- <div class="text-center py-3">
					<button type="button" class="btn btn-primary fw-bold fs-lg">به من خبر بده</button>
				</div> -->
			</div>
			<div class="px-2 pb-1 fw-bold">آگهی‌های بعدی منقضی شده است:</div>
		</ng-container>
	</ng-container>

	<div class="relative text-right px-2 px-md-4" *ngIf="mode == 'redirect'">
		<ngx-spinner name="sending" [fullScreen]="false" size="small" type="timer"></ngx-spinner>
		<form *ngIf="!(currentSubscription$|async)" #redirectForm="ngForm" class="py-2">
			<h6 class=" mb-3 lh-sm">می‌خواهی آگهی‌های شبیه <b>{{params._searchTitle}}</b> رو زودتر از بقیه برات بفرستم؟</h6>
			<div class="">
				<div *ngIf="!user" class="kp-form-row kp-required">
					<app-login (login)="subscribe()" [inline]="true" [show-name-input]="false"></app-login>
				</div>
				<div class="pt-2" *ngIf="user">
					<div
						[tooltip]="redirectForm.invalid || !(params.q || params.l)? 'شغلی که دنبالش هستید یا شهر مورد نظر را وارد کنید.' : undefined"
						trigger="focus" tabindex="0" containerClass="tooltip-warning">
						<button class="btn btn-primary w-100 no-disabled subscribe-btn"
							[disabled]="redirectForm.invalid || !(params.q || params.l)" (click)="subscribe()">
							<i class="fa fa-bell fs-lg ml-1"></i>
							ثبت گوش به زنگ</button>
					</div>
				</div>

			</div>
		</form>

	</div>

	<div *ngIf="mode == 'window'">
		<ng-container *ngTemplateOutlet="popupTemplate;"> </ng-container>
	</div>

	<ngx-smart-modal customClass="" #searchesModal identifier="searchesModal" customClass="modal-no-padding"
		(onOpenFinished)="mobileInput?.nativeElement.focus()">
		<ng-container *ngTemplateOutlet="popupTemplate;"> </ng-container>
	</ngx-smart-modal>

	<ng-template #popupTemplate>
		<div *ngIf="params" class="relative f-dark-gray container-capped-xs px-3" style="min-width: 300px;">
			<ngx-spinner name="sending" [fullScreen]="false" size="small" type="timer"></ngx-spinner>
			<form *ngIf="!(currentSubscription$|async)" #modalForm="ngForm"
				(submit)="Utility.validate(modalForm) && subscribe()" class="kp-message kp-message-info mx-0">
				<h6 class="">اولین کسی باش که از آگهی‌های جدید خبردار می‌شه!</h6>
				<div class="kp-message-body">
					<div [class.d-none]="user" class="kp-form-row kp-required my-0 p-2">
						<app-login (login)="subscribe()" [inline]="true" [flat]="true" heading=""
							[show-name-input]="false"></app-login>
					</div>
					<ng-container *ngIf="user">
						<div *ngIf="showSearchboxInPopup">
							<div class="my-2">به ما بگید دنبال چه کاری هستید و کجا؟</div>
							<app-search-box [showFilters]="false" [navigateEnabled]="false" [(ngModel)]="params" name="params">
							</app-search-box>
						</div>
						<div class="kp-form-footer my-2">
							<button type="button" class="btn btn-link f-red ml-2" (confirm)="close()">انصراف</button>
							<div class="kp-footer-primary">
								<button class="btn btn-yellow" type="submit"
									[class.disabled]="modalForm.invalid || !(params.q || params.l)"
									[tooltip]="modalForm.invalid || !(params.q || params.l)? 'شغلی که دنبالش هستید یا شهر مورد نظر را وارد کنید.' : undefined"
									trigger="focus" containerClass="tooltip-warning">
									<i class="fa fa-bell fs-lg ml-1"></i>
									ثبت گوش به زنگ</button>
							</div>
						</div>
					</ng-container>
				</div>

			</form>
			<ng-container *ngIf="(currentSubscription$|async)">
				<ng-container *ngIf="user">
					<div *ngIf="user.Seeker?.ExpiredPromote" class="text-center">
						<!-- <div class="kp-message kp-message-info mx-0">
							<h6>
								جستجوی مورد نظر شما با موفقیت ثبت شد.
							</h6>
							<div class="kp-message-body">
								<h6 class="f-red">
									شما بسته کارجوی پیشتاز را فعال نکرده‌اید.
								</h6>
								<h5>با {{userService.vanguardBasePrice|number}} تومان</h5>
								<h6>
									آگهی‌هایی که دنبالشون هستی رو هر روز روی گوشیت دریافت کن!
								</h6>
								<div class="btn btn-vanguard w-100 w-md-initial my-2" routerLink="/seeker/matching"
									(click)="searchesModal.close()">
									<img class="ml-2 icon-sm" src="/assets/images/icons/vanguard-seeker-white.svg" alt="کارجوی پیشتاز">
									<span>همین حالا پیشتاز شو</span>
								</div>
							</div>
						</div> -->
						<div class="kp-message kp-message-info mx-0">
							<h6>
								شغل مورد نظر شما با موفقت ثبت شد<br />
								و به صورت لحظه‌ای جستجو و بروزرسانی می‌شود.
							</h6>
							<div class="kp-message-body">
								<h6>
									جهت دریافت این آگهی‌های جدید، کافیست پیشتاز شوید.
								</h6>

								<!-- <div class="btn btn-vanguard w-100 w-md-initial my-2" routerLink="/seeker/karpasha"
									(click)="searchesModal.close()">
									<img class="ml-2 icon-sm" src="/assets/images/icons/vanguard-seeker-white.svg" alt="کارجوی پیشتاز">
									<span>همین حالا پیشتاز شو</span>
								</div> -->
							</div>
							<app-seeker-vanguard-packages class="f-initial" url="/seeker/matching" [referer]="'newform'"
								[minimal]="true"></app-seeker-vanguard-packages>

						</div>
					</div>
					<div *ngIf="!user.Seeker?.ExpiredPromote">
						از این به بعد آگهی‌های مربوط به این جستجو برای شما ارسال می‌شه.
						<div class="text-center my-2">
							<button class="btn btn-secondary" (click)="close()">
								باشه!
							</button>

						</div>
					</div>
				</ng-container>
			</ng-container>

		</div>
	</ng-template>

</ng-container>